(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 35243:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(9828);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ PageViewAnalytics; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13711);



function PageViewAnalytics(param) {
    var template = param.template;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = "".concat(router === null || router === void 0 ? void 0 : router.locale).concat(router === null || router === void 0 ? void 0 : router.pathname);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__/* .PageViewAnalytics */ .WA, {
        template: template,
        pathname: pathname
    });
}


/***/ }),

/***/ 52763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UG": function() { return /* binding */ processAlgoliaFilters; },
/* harmony export */   "nZ": function() { return /* binding */ serializeAlgoliaResults; }
/* harmony export */ });
/* unused harmony exports SUB_CATEGORIES_SEPARATOR, getDefaultFacetsFromAlgoliaProps */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _lib_algolia_sync_set_settings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10348);
/* harmony import */ var _utils_check_empty_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86867);







var SUB_CATEGORIES_SEPARATOR = " > ";
function serializeAlgoliaResults(hits) {
    return hits === null || hits === void 0 ? void 0 : hits.map(function(hit) {
        var ref;
        if (hit === null || hit === void 0 ? void 0 : hit.productCard) return hit;
        var _ref = hit !== null && hit !== void 0 ? hit : {}, shopify = _ref.shopify, storyblok = _ref.storyblok, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, [
            "shopify",
            "storyblok"
        ]);
        var ref1, ref2, ref3;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, rest), {
            shopifyId: (ref1 = shopify === null || shopify === void 0 ? void 0 : shopify.shopifyId) !== null && ref1 !== void 0 ? ref1 : null
        }), storyblok), {
            wishlistDetails: {
                inList: true,
                uuid: (ref2 = storyblok === null || storyblok === void 0 ? void 0 : storyblok.uuid) !== null && ref2 !== void 0 ? ref2 : null,
                variantId: shopify === null || shopify === void 0 ? void 0 : (ref = shopify.defaultVariant) === null || ref === void 0 ? void 0 : ref.id
            },
            variants: (ref3 = shopify === null || shopify === void 0 ? void 0 : shopify.variants) !== null && ref3 !== void 0 ? ref3 : null,
            productCard: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, shopify, storyblok)
        });
    });
}
function processAlgoliaFilters(filters) {
    var ref;
    var ref1;
    return (ref1 = (ref = filters === null || filters === void 0 ? void 0 : filters.filter(function(string) {
        return (0,_utils_check_empty_string__WEBPACK_IMPORTED_MODULE_4__/* .stringIsNotEmpty */ .b)(string);
    })) === null || ref === void 0 ? void 0 : ref.join(" AND ")) !== null && ref1 !== void 0 ? ref1 : "";
}
/**
 * It takes a list of facets and returns a list of facets, but with the subcategories of each category
 * added to the category
 * @param {FacetsResult[]} facets - FacetsResult[]
 * @returns An array of facets, with the subcategories nested under the categories.
 */ function processCategoriesAndSubCategoriesFacets(facets) {
    var ref;
    // Isolate categories facet
    var categories = facets === null || facets === void 0 ? void 0 : facets.find(function(entry) {
        return (entry === null || entry === void 0 ? void 0 : entry.type) === FACETS.CATEGORIES_V2;
    });
    // Isolate sub categories facet
    var subCategories = facets === null || facets === void 0 ? void 0 : facets.find(function(entry) {
        return (entry === null || entry === void 0 ? void 0 : entry.type) === FACETS.SUB_CATEGORIES;
    });
    return (ref = facets === null || facets === void 0 ? void 0 : facets.filter(function(facet) {
        // If there is no facet categories then we don't want to hide the sub categories
        if (!categories) return facet;
        // If there is a categories facet then we want to hide to hide the sub categories
        // As they will be displayed under each relevant category
        return (facet === null || facet === void 0 ? void 0 : facet.type) !== FACETS.SUB_CATEGORIES;
    })) === null || ref === void 0 ? void 0 : ref.map(function(facet) {
        var ref;
        // If there is no categories facet
        if (!categories && (facet === null || facet === void 0 ? void 0 : facet.type) === FACETS.SUB_CATEGORIES) {
            var ref1;
            return _object_spread_props(_object_spread({}, facet), {
                // Map over each sub categories facet value
                values: facet === null || facet === void 0 ? void 0 : (ref1 = facet.values) === null || ref1 === void 0 ? void 0 : ref1.map(function(entry) {
                    var ref, ref1, ref2;
                    var hasParentFacet = entry === null || entry === void 0 ? void 0 : (ref = entry.label) === null || ref === void 0 ? void 0 : ref.includes(SUB_CATEGORIES_SEPARATOR);
                    return _object_spread_props(_object_spread({}, entry), {
                        // Remove parent category string (category > sub category)
                        label: hasParentFacet ? (ref2 = entry === null || entry === void 0 ? void 0 : (ref1 = entry.label) === null || ref1 === void 0 ? void 0 : ref1.split(SUB_CATEGORIES_SEPARATOR)) === null || ref2 === void 0 ? void 0 : ref2[1] : entry === null || entry === void 0 ? void 0 : entry.label
                    });
                })
            });
        }
        // If there are categories and current facet is not category then it doesn't need to be processed
        if ((facet === null || facet === void 0 ? void 0 : facet.type) !== FACETS.CATEGORIES_V2) return facet;
        return _object_spread_props(_object_spread({}, facet), {
            // Add a sub values object with relevant sub categories
            subValues: {
                type: FACETS.SUB_CATEGORIES,
                values: facet === null || facet === void 0 ? void 0 : (ref = facet.values) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, entry) {
                    var ref, ref1;
                    // Isolate category name (eg: Bagues)
                    var categoryName = entry.label;
                    // Isolate the category string to trim (eg: Bagues >)
                    var str = "".concat(categoryName, " >");
                    var ref2;
                    return _object_spread_props(_object_spread({}, acc), // Create object {[catName]: [...subValues]}
                    // eg: {Bagues: [{label: "Alliances", value: "Bagues > Alliances"}]}
                    _define_property({}, categoryName, (ref2 = (ref1 = subCategories === null || subCategories === void 0 ? void 0 : (ref = subCategories.values) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                        var ref;
                        return item === null || item === void 0 ? void 0 : (ref = item.label) === null || ref === void 0 ? void 0 : ref.startsWith(str);
                    })) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                        var ref;
                        return _object_spread_props(_object_spread({}, item), {
                            // Format facet label string
                            label: item === null || item === void 0 ? void 0 : (ref = item.label) === null || ref === void 0 ? void 0 : ref.replace(str, "")
                        });
                    })) !== null && ref2 !== void 0 ? ref2 : []));
                }, {})
            }
        });
    });
}
var STONES_FACET_VALUES_AMOUNT_TO_DISPLAY = 15;
/**
 * It takes the initial data from Algolia and returns an array of facets
 * @param {AlgoliaInitialSearchResponse} data - AlgoliaInitialSearchResponse
 * @returns An array of objects with the following shape:
 * {
 *   type: string,
 *   values: [
 *     {
 *       label: string,
 *       value: string,
 *     }
 *   ]
 * }
 */ function getDefaultFacetsFromAlgoliaProps(data, filters) {
    var ref, ref1, ref2, ref3, ref4;
    var ref5;
    var facets = (ref5 = data === null || data === void 0 ? void 0 : (ref = data.initialData) === null || ref === void 0 ? void 0 : (ref1 = ref.pages) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.facets) !== null && ref5 !== void 0 ? ref5 : {};
    var ref6;
    var processedFacets = (ref6 = (ref4 = (ref3 = Object.entries(facets)) === null || ref3 === void 0 ? void 0 : ref3.filter(function(param) {
        var _param = _sliced_to_array(param, 1), key = _param[0];
        var ref;
        return !((ref = Object.keys(filters)) === null || ref === void 0 ? void 0 : ref.includes(key));
    })) === null || ref4 === void 0 ? void 0 : ref4.map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        var ref, ref1, ref2, ref3;
        /**
         * For the stores facet values, WB team decided decided there were too many options listed
         * To fix this, we will only display the X stones with the most results
         */ var values = // If current facet is stones
        key === FACETS.STONE ? (ref2 = (ref1 = (ref = Object.keys(value)) === null || ref === void 0 ? void 0 : ref.sort(function(currentKey, nextKey) {
            return value[nextKey] - value[currentKey];
        })) === null || ref1 === void 0 ? void 0 : ref1.slice(0, STONES_FACET_VALUES_AMOUNT_TO_DISPLAY)) === null || ref2 === void 0 ? void 0 : ref2.sort() : Object.keys(value);
        var ref4;
        return {
            type: key,
            values: (ref4 = (ref3 = values === null || values === void 0 ? void 0 : values.map(function(val) {
                return {
                    label: val,
                    value: val
                };
            })) === null || ref3 === void 0 ? void 0 : ref3.filter(function(item) {
                return item;
            })) !== null && ref4 !== void 0 ? ref4 : []
        };
    })) !== null && ref6 !== void 0 ? ref6 : [];
    return processCategoriesAndSubCategoriesFacets(processedFacets);
}


/***/ }),

/***/ 9828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/PageViewAnalytics/index.tsx
var PageViewAnalytics = __webpack_require__(68971);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/lib/algolia/serialize-algolia-results.ts
var serialize_algolia_results = __webpack_require__(52763);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Spinner/index.js
var Spinner = __webpack_require__(38137);
// EXTERNAL MODULE: ./src/@types/grid-preset.ts
var grid_preset = __webpack_require__(31538);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/lib/link-resolver.ts + 3 modules
var link_resolver = __webpack_require__(3523);
// EXTERNAL MODULE: ./src/lib/storyblok-types.ts
var storyblok_types = __webpack_require__(18685);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.tsx + 17 modules
var Icons = __webpack_require__(54678);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/hooks/useLocale/index.ts
var useLocale = __webpack_require__(66794);
// EXTERNAL MODULE: ./src/hooks/useOnKeyDown/index.ts
var useOnKeyDown = __webpack_require__(95119);
// EXTERNAL MODULE: ./src/utils/check-empty-string.ts
var check_empty_string = __webpack_require__(86867);
// EXTERNAL MODULE: ./src/utils/get-query-params.ts
var get_query_params = __webpack_require__(16731);
// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
// EXTERNAL MODULE: ./src/components/UI/SearchBar/styles.module.scss
var styles_module = __webpack_require__(88920);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/UI/SearchBar/index.tsx

















var cx = bind_default().bind((styles_module_default()));
function SearchBar(param) {
    var className = param.className, inputClassName = param.inputClassName, hasAutocomplete = param.hasAutocomplete, autocompleteValue = param.autocompleteValue, suggestedValue = param.suggestedValue, hasReset = param.hasReset, isSearching = param.isSearching, isFetching = param.isFetching, inputValue = param.inputValue;
    var t = (0,lib/* useTranslate */.qM)();
    var inputRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var locale = (0,useLocale/* default */.Z)();
    var ref = (0,react.useState)(false), isFocused = ref[0], setIsFocused = ref[1];
    var ref1 = (0,react.useState)(false), isFullySuggested = ref1[0], setIsFullySuggested = ref1[1];
    var ref2 = (0,react.useState)(true), shouldDisplayPlaceholder = ref2[0], setShouldDisplayPlaceHolder = ref2[1];
    var inputStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Input30_56SangBleu */.C.Input30_56SangBleu,
        color: colors/* GlobalThemeColors.Black */.b.Black
    });
    var onInputChange = (0,react.useCallback)(function(e) {
        var q = e.currentTarget.textContent;
        router.push({
            pathname: (0,link_resolver/* default */.Z)({
                content: {
                    component: storyblok_types/* STORYBLOK_TYPES.SEARCH */.nI.SEARCH
                }
            }, locale),
            query: {
                q: q
            }
        }, null, {
            shallow: true,
            locale: locale
        });
    }, [
        router,
        locale
    ]);
    var clearSearch = (0,react.useCallback)(function() {
        router.push({
            pathname: (0,link_resolver/* default */.Z)({
                content: {
                    component: storyblok_types/* STORYBLOK_TYPES.SEARCH */.nI.SEARCH
                }
            }, locale)
        }, null, {
            shallow: true,
            locale: locale
        });
        inputRef.current.textContent = "";
        setIsFullySuggested(false);
    }, []);
    var params = (0,react.useMemo)(function() {
        return (0,get_query_params/* getQueryParams */.vl)();
    }, [
        router
    ]);
    var q = params.q;
    var query = q === null || q === void 0 ? void 0 : q.toString();
    (0,react.useEffect)(function() {
        if (query) {
            var ref;
            setShouldDisplayPlaceHolder(false);
            inputRef.current.textContent = (ref = query === null || query === void 0 ? void 0 : query.toString()) === null || ref === void 0 ? void 0 : ref.replaceAll("+", " ");
        } else {
            setShouldDisplayPlaceHolder(true);
        }
    }, []);
    (0,react.useEffect)(function() {
        isFocused || isSearching ? setShouldDisplayPlaceHolder(false) : setShouldDisplayPlaceHolder(true);
    }, [
        isFocused,
        isSearching
    ]);
    var focusAtEnd = function() {
        // This function is used to focus at the end of the input
        // Because its a contenteditable element, the cursor has not the good position when overriding the value
        var input = inputRef.current;
        var range = document.createRange();
        var selection = window.getSelection();
        var lastChildNode = input.childNodes[input.childNodes.length - 1];
        range.setStart(lastChildNode, lastChildNode.length);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
    };
    var onClickReset = function(e) {
        e.preventDefault();
        clearSearch();
    };
    var onKeyDown = function(e) {
        if (e.keyCode === 13 || e.keyCode === 39) {
            e.preventDefault();
        }
    };
    var onSuggestion = function() {
        if (hasAutocomplete && suggestedValue) {
            inputRef.current.textContent = suggestedValue;
            onInputChange({
                currentTarget: inputRef.current
            });
            focusAtEnd();
            setIsFullySuggested(true);
        }
    };
    var onInput = function(e) {
        onInputChange(e);
        setIsFullySuggested(false);
    };
    (0,useOnKeyDown/* default */.Z)(27, function() {
        if ((0,check_empty_string/* stringIsNotEmpty */.b)(query)) clearSearch();
    });
    (0,useOnKeyDown/* default */.Z)(13, onSuggestion);
    (0,useOnKeyDown/* default */.Z)(39, onSuggestion);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx((styles_module_default()).SearchBar, className, {
            hasReset: hasReset && isSearching,
            hasAutocomplete: hasAutocomplete
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: cx((styles_module_default()).searchInput, inputStyle, inputClassName, {
                    isWaitingForFocus: !isSearching && !isFocused,
                    hasNoAutocompleteValue: hasAutocomplete && !autocompleteValue,
                    hasNoInput: !(0,check_empty_string/* stringIsNotEmpty */.b)(query)
                }),
                role: "textbox",
                spellCheck: false,
                ref: inputRef,
                onInput: onInput,
                onKeyDown: onKeyDown,
                onFocus: function() {
                    setIsFocused(true);
                },
                onBlur: function() {
                    setIsFocused(false);
                },
                contentEditable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: cx((styles_module_default()).fakePlaceholder, inputStyle, inputClassName, {
                    shouldDisplayPlaceholder: shouldDisplayPlaceholder
                }),
                children: t(dictionary/* FORM.SEARCH */.Yc.SEARCH)
            }),
            hasAutocomplete && autocompleteValue && !isFetching && !isFullySuggested && (0,check_empty_string/* stringIsNotEmpty */.b)(query) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: cx((styles_module_default()).autocompleteValue, inputStyle),
                children: autocompleteValue
            }),
            hasReset && isSearching && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": t(dictionary/* FORM.RESET */.Yc.RESET),
                onClick: function(e) {
                    onClickReset && onClickReset(e);
                },
                className: (styles_module_default()).resetCta,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* BigCloseIcon */.R1, {
                    className: (styles_module_default()).closeIcon
                })
            })
        ]
    });
}
SearchBar.defaultProps = {
    hasReset: false,
    hasAutocomplete: false,
    isSearching: false
};
/* harmony default export */ var UI_SearchBar = (SearchBar);

// EXTERNAL MODULE: ./src/components/UI/SearchContent/SearchInput/styles.module.scss
var SearchInput_styles_module = __webpack_require__(29169);
var SearchInput_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchInput_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/SearchContent/SearchInput/index.tsx







var SearchInput_cx = bind_default().bind((SearchInput_styles_module_default()));
function SearchInput(param) {
    var className = param.className, inputClassName = param.inputClassName, isSearching = param.isSearching, isFetching = param.isFetching, hasAutocomplete = param.hasAutocomplete, autocompleteValue = param.autocompleteValue, suggestedValue = param.suggestedValue;
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: SearchInput_cx((SearchInput_styles_module_default()).SearchInput, gridStyle, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (SearchInput_styles_module_default()).content,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_SearchBar, {
                className: (SearchInput_styles_module_default()).searchBar,
                hasReset: true,
                hasAutocomplete: true,
                isSearching: isSearching,
                isFetching: isFetching,
                inputClassName: inputClassName,
                autocompleteValue: autocompleteValue,
                suggestedValue: suggestedValue
            })
        })
    });
}
SearchInput.defaultProps = {};
/* harmony default export */ var SearchContent_SearchInput = (SearchInput);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./src/components/UI/ProductCard/index.tsx + 8 modules
var ProductCard = __webpack_require__(23816);
// EXTERNAL MODULE: ./src/components/UI/SearchContent/SearchRecommendedProducts/styles.module.scss
var SearchRecommendedProducts_styles_module = __webpack_require__(421);
var SearchRecommendedProducts_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchRecommendedProducts_styles_module);
// EXTERNAL MODULE: ./src/components/UI/ProductCard/types.ts
var types = __webpack_require__(72206);
;// CONCATENATED MODULE: ./src/components/UI/SearchContent/SearchRecommendedProducts/index.tsx














var SearchRecommendedProducts_cx = bind_default().bind((SearchRecommendedProducts_styles_module_default()));
function SearchRecommendedProducts(param) {
    var className = param.className, hasNoResults = param.hasNoResults, upsales = param.upsales;
    var t = (0,lib/* useTranslate */.qM)();
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12Grotesk */.C.Label12Grotesk,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
        color: colors/* GlobalThemeColors.Black */.b.Black
    });
    var noResultStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label24Grotesk */.C.Label24Grotesk,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
        color: colors/* GlobalThemeColors.Black */.b.Black
    });
    return upsales && (upsales === null || upsales === void 0 ? void 0 : upsales.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: SearchRecommendedProducts_cx((SearchRecommendedProducts_styles_module_default()).SearchRecommendedProducts, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: SearchRecommendedProducts_cx(gridStyle, (SearchRecommendedProducts_styles_module_default()).gridTop),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: SearchRecommendedProducts_cx((SearchRecommendedProducts_styles_module_default()).title, titleStyle),
                        children: t(dictionary/* SEARCH.MOST_POPULAR */.mo.MOST_POPULAR)
                    }),
                    hasNoResults && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: SearchRecommendedProducts_cx((SearchRecommendedProducts_styles_module_default()).noResults, noResultStyle),
                        children: t(dictionary/* SEARCH.EMPTY_RESULTS */.mo.EMPTY_RESULTS)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: SearchRecommendedProducts_cx(gridStyle, (SearchRecommendedProducts_styles_module_default()).gridBody),
                children: upsales === null || upsales === void 0 ? void 0 : upsales.map(function(product, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, (0,_object_spread/* default */.Z)({
                        className: (SearchRecommendedProducts_styles_module_default()).item,
                        layout: types/* CARD_PRODUCT_LAYOUT.SEARCH_GRID */.u.SEARCH_GRID
                    }, product), "upsale_".concat(index));
                })
            })
        ]
    }) : null;
}
SearchRecommendedProducts.defaultProps = {};
/* harmony default export */ var SearchContent_SearchRecommendedProducts = (SearchRecommendedProducts);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/dist/index.mjs
var dist = __webpack_require__(18357);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useIsomorphicLayoutEffect/index.js
var useIsomorphicLayoutEffect = __webpack_require__(56346);
;// CONCATENATED MODULE: ./src/hooks/useTranslatedSmartCount/index.ts

function useTranslatedSmartCount(keys, count) {
    var ref;
    var t = (0,lib/* useTranslate */.qM)();
    var TRANSLATION_KEY = (ref = keys === null || keys === void 0 ? void 0 : keys.map(function(key) {
        return t(key);
    })) === null || ref === void 0 ? void 0 : ref.join(" |||| ");
    return t(TRANSLATION_KEY, {
        smart_count: count
    });
}

// EXTERNAL MODULE: ./src/components/UI/SearchContent/SearchResultsGrid/styles.module.scss
var SearchResultsGrid_styles_module = __webpack_require__(45389);
var SearchResultsGrid_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchResultsGrid_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/SearchContent/SearchResultsGrid/index.tsx

















var SearchResultsGrid_cx = bind_default().bind((SearchResultsGrid_styles_module_default()));
function SearchResultsGrid(param) {
    var className = param.className, results = param.results, hasNextPage = param.hasNextPage, isFetchingNextPage = param.isFetchingNextPage, fetchNextPage = param.fetchNextPage, nbHits = param.nbHits, searchQuery = param.searchQuery;
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12Grotesk */.C.Label12Grotesk,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,dist/* useInView */.YD)({
        rootMargin: "0px 0px 600px 0px"
    }), 2), inViewRef = ref[0], inView = ref[1];
    (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(function() {
        if (inView && hasNextPage) fetchNextPage();
    }, [
        inView,
        hasNextPage
    ]);
    var COUNT_TRANSLATION = useTranslatedSmartCount([
        dictionary/* SEARCH.COUNT_SINGLE_RESULT */.mo.COUNT_SINGLE_RESULT,
        dictionary/* SEARCH.COUNT_MULTIPLE_RESULTS */.mo.COUNT_MULTIPLE_RESULTS
    ], nbHits);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: SearchResultsGrid_cx((SearchResultsGrid_styles_module_default()).SearchResultsGrid, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: SearchResultsGrid_cx(gridStyle, (SearchResultsGrid_styles_module_default()).grid),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SearchResultsGrid_styles_module_default()).gridTop,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: titleStyle,
                        children: "".concat(COUNT_TRANSLATION, ' "').concat(searchQuery, '"')
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: SearchResultsGrid_cx(gridStyle, (SearchResultsGrid_styles_module_default()).grid),
                children: [
                    results === null || results === void 0 ? void 0 : results.map(function(result, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SearchResultsGrid_styles_module_default()).item,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, (0,_object_spread/* default */.Z)({
                                layout: types/* CARD_PRODUCT_LAYOUT.SEARCH_GRID */.u.SEARCH_GRID
                            }, result))
                        }, "search_result_".concat(index));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SearchResultsGrid_styles_module_default()).marker,
                        ref: inViewRef,
                        children: isFetchingNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SearchResultsGrid_styles_module_default()).spinnerWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
                                className: (SearchResultsGrid_styles_module_default()).spinner
                            })
                        })
                    })
                ]
            })
        ]
    });
}
SearchResultsGrid.defaultProps = {};
/* harmony default export */ var SearchContent_SearchResultsGrid = (SearchResultsGrid);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(59403);
// EXTERNAL MODULE: ./src/lib/algolia/clients.ts + 1 modules
var clients = __webpack_require__(59529);
// EXTERNAL MODULE: ./src/lib/algolia/constants.ts
var constants = __webpack_require__(75639);
;// CONCATENATED MODULE: ./src/lib/algolia/index.ts



// EXTERNAL MODULE: ./src/utils/get-algolia-product-index.ts
var get_algolia_product_index = __webpack_require__(17831);
;// CONCATENATED MODULE: ./src/hooks/useAlgoliaSearchQuery/index.ts





function useAlgoliaSearchQuery(param) {
    var sortBy = param.sortBy, q = param.q, locale = param.locale, enabled = param.enabled, key = param.key, queryOptions = param.queryOptions, hitsPerPage = param.hitsPerPage;
    var indexName = (0,get_algolia_product_index/* default */.Z)();
    var index = clients/* algoliaSearch.client.initIndex */.v.client.initIndex("".concat(locale, "_").concat(indexName));
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)([
        key,
        {},
        q,
        locale,
        sortBy
    ], function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _pageParam, pageParam, res, nextPage, ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 0 : _pageParam;
                        return [
                            4,
                            index.search(q, {
                                page: pageParam,
                                typoTolerance: false,
                                analyticsTags: [
                                    "search"
                                ],
                                attributesToHighlight: [
                                    "name",
                                    "designer",
                                    "metal",
                                    "stone",
                                    "categories"
                                ],
                                restrictHighlightAndSnippetArrays: true,
                                hitsPerPage: hitsPerPage !== null && hitsPerPage !== void 0 ? hitsPerPage : constants/* ALGOLIA_HITS_PER_PAGE */.l9
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        nextPage = (res === null || res === void 0 ? void 0 : res.nbPages) > (res === null || res === void 0 ? void 0 : res.page) + 1 ? (res === null || res === void 0 ? void 0 : res.page) + 1 : null;
                        return [
                            2,
                            {
                                data: (ref = res === null || res === void 0 ? void 0 : res.hits) !== null && ref !== void 0 ? ref : null,
                                page: nextPage,
                                nbHits: (ref1 = res === null || res === void 0 ? void 0 : res.nbHits) !== null && ref1 !== void 0 ? ref1 : null
                            }
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: function(data) {
            var ref;
            queryOptions === null || queryOptions === void 0 ? void 0 : (ref = queryOptions.onSuccess) === null || ref === void 0 ? void 0 : ref.call(queryOptions, data);
        },
        keepPreviousData: true,
        getNextPageParam: function(lastPage) {
            return lastPage === null || lastPage === void 0 ? void 0 : lastPage.page;
        },
        refetchOnWindowFocus: false,
        enabled: enabled
    });
}
/* harmony default export */ var hooks_useAlgoliaSearchQuery = (useAlgoliaSearchQuery);

;// CONCATENATED MODULE: ./src/hooks/useDebounce/index.ts

function useDebounce(value, delay) {
    var ref = (0,react.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react.useEffect)(function() {
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
/* harmony default export */ var hooks_useDebounce = (useDebounce);

;// CONCATENATED MODULE: ./src/utils/get-algolia-autocomplete-result.ts
/**
 * It takes a value, a query, and a tag name, and returns the value with the tag name and query removed
 * @param value - The value of the result.
 * @param query - The search query
 * @param tagName - The tag name of the result. For example, if the result is a link, the tag name is
 * "a".
 * @returns the value of the query parameter.
 */ function sanitizeResultNameForValue(value, query, tagName) {
    var regex = new RegExp("<".concat(tagName, "\\s*.*>\\s*.*<\\/").concat(tagName, ">"), "g");
    var replacedValue = value === null || value === void 0 ? void 0 : value.replace(regex, query);
    var ref;
    return (ref = replacedValue === null || replacedValue === void 0 ? void 0 : replacedValue.substring((replacedValue === null || replacedValue === void 0 ? void 0 : replacedValue.indexOf(query)) + (query === null || query === void 0 ? void 0 : query.length))) !== null && ref !== void 0 ? ref : null;
}
/**
 * It takes the result from Algolia's autocomplete API, the query that was typed in, and the HTML tag
 * that will be used to wrap the matched text. It then returns the matched text in lowercase
 * @param {any} result - The result object from Algolia
 * @param {string} query - The query that the user typed in the search bar.
 * @param {string} htmlTag - The HTML tag that will be used to wrap the matched text.
 * @returns A string
 */ function getAlgoliaAutocompleteResult(result, query, htmlTag) {
    var ref, ref1, ref2, ref3;
    var ref4;
    var highlightResult = (ref4 = result === null || result === void 0 ? void 0 : result._highlightResult) !== null && ref4 !== void 0 ? ref4 : {};
    var ref5;
    /* Filtering the result object from Algolia's autocomplete API to find the value that
  matches the query. */ var matchedValue = (ref5 = (ref1 = (ref = Object.values(highlightResult)) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
        var ref;
        var itemMatchLevel = (item === null || item === void 0 ? void 0 : item.matchLevel) || (item === null || item === void 0 ? void 0 : (ref = item[0]) === null || ref === void 0 ? void 0 : ref.matchLevel);
        return itemMatchLevel === "full";
    })) === null || ref1 === void 0 ? void 0 : ref1.flat()) !== null && ref5 !== void 0 ? ref5 : null;
    var ref6;
    var futureSentence = (ref6 = (ref3 = sanitizeResultNameForValue(matchedValue === null || matchedValue === void 0 ? void 0 : (ref2 = matchedValue[0]) === null || ref2 === void 0 ? void 0 : ref2.value, query, htmlTag)) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) !== null && ref6 !== void 0 ? ref6 : null;
    return futureSentence;
}

// EXTERNAL MODULE: ./src/components/UI/SearchContent/styles.module.scss
var SearchContent_styles_module = __webpack_require__(35335);
var SearchContent_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchContent_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/SearchContent/index.tsx

















var SearchContent_cx = bind_default().bind((SearchContent_styles_module_default()));
var HITS_PER_PAGE = 8;
function SearchContent(param) {
    var className = param.className, upsales = param.upsales;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,react.useState)(false), isSearching = ref6[0], setIsSearching = ref6[1];
    var router = (0,next_router.useRouter)();
    var locale = (0,useLocale/* default */.Z)();
    var params = (0,react.useMemo)(function() {
        return (0,get_query_params/* getQueryParams */.vl)();
    }, [
        router
    ]);
    var q = params.q;
    var ref7;
    var query = (ref7 = q === null || q === void 0 ? void 0 : q.toString()) !== null && ref7 !== void 0 ? ref7 : "";
    var ref8;
    var debouncedValue = (ref8 = hooks_useDebounce(query, 150)) !== null && ref8 !== void 0 ? ref8 : null;
    var sanitizedDebouncedValue = debouncedValue && (debouncedValue === null || debouncedValue === void 0 ? void 0 : debouncedValue.length) > 0 ? debouncedValue === null || debouncedValue === void 0 ? void 0 : debouncedValue.replaceAll("+", " ") : "";
    (0,react.useEffect)(function() {
        setIsSearching((debouncedValue === null || debouncedValue === void 0 ? void 0 : debouncedValue.length) >= 3);
    }, [
        debouncedValue
    ]);
    var ref9 = hooks_useAlgoliaSearchQuery({
        q: debouncedValue,
        locale: locale,
        key: "search_products",
        hitsPerPage: HITS_PER_PAGE,
        enabled: isSearching
    }), data = ref9.data, isFetching = ref9.isFetching, isSuccess = ref9.isSuccess, isFetchingNextPage = ref9.isFetchingNextPage, fetchNextPage = ref9.fetchNextPage, hasNextPage = ref9.hasNextPage;
    var ref10;
    var debouncedNbPages = (ref10 = data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.length) !== null && ref10 !== void 0 ? ref10 : 0;
    var ref11;
    var debouncedNbHits = (ref11 = data === null || data === void 0 ? void 0 : (ref1 = data.pages) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.nbHits) !== null && ref11 !== void 0 ? ref11 : 0;
    var memoizedDebouncedAlgoliaData = (0,react.useMemo)(function() {
        return {
            debouncedNbHits: debouncedNbHits === null || debouncedNbHits === void 0 ? void 0 : debouncedNbHits.toString(),
            debouncedNbPages: debouncedNbPages === null || debouncedNbPages === void 0 ? void 0 : debouncedNbPages.toString(),
            debouncedValue: debouncedValue
        };
    }, [
        debouncedNbHits,
        debouncedNbPages,
        debouncedValue
    ]);
    var ref12;
    var results = isSearching ? (ref12 = data === null || data === void 0 ? void 0 : (ref3 = data.pages) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(acc, page) {
        return (0,_to_consumable_array/* default */.Z)((0,serialize_algolia_results/* serializeAlgoliaResults */.nZ)(acc)).concat((0,_to_consumable_array/* default */.Z)((0,serialize_algolia_results/* serializeAlgoliaResults */.nZ)(page.data)));
    }, [])) !== null && ref12 !== void 0 ? ref12 : [] : [];
    var autocompleteResult = results && (sanitizedDebouncedValue === null || sanitizedDebouncedValue === void 0 ? void 0 : sanitizedDebouncedValue.length) ? getAlgoliaAutocompleteResult(results === null || results === void 0 ? void 0 : results[0], sanitizedDebouncedValue, "em") : null;
    var suggestedValue = autocompleteResult ? "".concat(sanitizedDebouncedValue).concat(autocompleteResult) : null;
    var hasResults = isSuccess && !isFetching && (results === null || results === void 0 ? void 0 : results.length) > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: SearchContent_cx((SearchContent_styles_module_default()).SearchContent, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: SearchContent_cx((SearchContent_styles_module_default()).top, {
                    isSearching: isSearching
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContent_SearchInput, {
                    hasAutocomplete: true,
                    isSearching: isSearching,
                    isFetching: isFetching,
                    autocompleteValue: autocompleteResult,
                    suggestedValue: suggestedValue,
                    inputClassName: (SearchContent_styles_module_default()).mainInput,
                    className: (SearchContent_styles_module_default()).input
                })
            }),
            (hasResults || isFetching) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: SearchContent_cx((SearchContent_styles_module_default()).body),
                children: [
                    hasResults && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContent_SearchResultsGrid, {
                        results: results,
                        nbHits: data === null || data === void 0 ? void 0 : (ref4 = data.pages) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.nbHits,
                        searchQuery: sanitizedDebouncedValue,
                        hasNextPage: hasNextPage,
                        fetchNextPage: fetchNextPage,
                        isFetchingNextPage: isFetchingNextPage
                    }),
                    isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SearchContent_styles_module_default()).spinnerWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
                            className: (SearchContent_styles_module_default()).spinner,
                            color: colors/* GlobalThemeColors.Black */.b.Black
                        })
                    })
                ]
            }),
            !hasResults && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SearchContent_styles_module_default()).bottom,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContent_SearchRecommendedProducts, {
                    upsales: upsales,
                    hasNoResults: isSearching
                })
            })
        ]
    });
}
SearchContent.defaultProps = {};
/* harmony default export */ var UI_SearchContent = (SearchContent);

;// CONCATENATED MODULE: ./src/pages/search/index.tsx



function Search(param) {
    var slices = param.slices, upsales = param.upsales;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_SearchContent, {
                upsales: upsales
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageViewAnalytics/* PageViewAnalytics */.W, {
                template: "search"
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ var search = (Search);


/***/ }),

/***/ 17831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getAlgoliaProductIndex; }
/* harmony export */ });
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96660);

function getAlgoliaProductIndex() {
    return "".concat("production", "_").concat(_lib_constants__WEBPACK_IMPORTED_MODULE_0__/* .ALGOLIA_PRODUCT_INDEX */ .of);
}


/***/ }),

/***/ 88920:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SearchBar":"styles_SearchBar__0lO3b","hasReset":"styles_hasReset__TWAoA","searchInputComponent":"styles_searchInputComponent__Lgl6j","hasAutocomplete":"styles_hasAutocomplete__dC7K1","autocompleteValue":"styles_autocompleteValue__DEuDb","searchInput":"styles_searchInput__u9SOP","fakePlaceholder":"styles_fakePlaceholder__EuM26","hasNoInput":"styles_hasNoInput__MXIC2","isWaitingForFocus":"styles_isWaitingForFocus__YjfGF","hasNoAutocompleteValue":"styles_hasNoAutocompleteValue___VErK","shouldDisplayPlaceholder":"styles_shouldDisplayPlaceholder__7V8fJ","resetCta":"styles_resetCta__sNsfw","closeIcon":"styles_closeIcon__TRAz9"};

/***/ }),

/***/ 29169:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SearchInput":"styles_SearchInput__twfLm","content":"styles_content__100T_"};

/***/ }),

/***/ 421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SearchRecommendedProducts":"styles_SearchRecommendedProducts__fNzIz","gridTop":"styles_gridTop__2Cwe_","title":"styles_title___CXCV","noResults":"styles_noResults__jhyFs","gridBody":"styles_gridBody__W16dC","item":"styles_item__J0juw"};

/***/ }),

/***/ 45389:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SearchResultsGrid":"styles_SearchResultsGrid__jk0CS","grid":"styles_grid__UGhrI","gridTop":"styles_gridTop__Y2Tcg","item":"styles_item__OZrda"};

/***/ }),

/***/ 35335:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SearchContent":"styles_SearchContent__0KCCP","top":"styles_top__av4dQ","body":"styles_body__gkBkK","spinnerWrapper":"styles_spinnerWrapper__28w40","spinner":"styles_spinner__ZzASD","bottom":"styles_bottom__WU7yy"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7924,7130,2873,3816,9774,2888,179], function() { return __webpack_exec__(35243); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);